// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-F1E0BCBE-514A-44BC-AB9D-A587BE0A37BD .component-hr,\n#V-F1E0BCBE-514A-44BC-AB9D-A587BE0A37BD .hr-component {\n  margin-top: 0;\n}\n", "",{"version":3,"sources":["webpack://src/Sell/invoiceDetail/invoiceDetail.less"],"names":[],"mappings":"AAAA;;EAEQ,aAAA;AACR","sourcesContent":["#V-F1E0BCBE-514A-44BC-AB9D-A587BE0A37BD{\n    .component-hr, .hr-component {\n        margin-top: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
